<script>
import { mapGetters } from 'vuex'
import actions from './actions'
export default {
    mixins: [actions],

    data() {
        return {
            selectedService: null,
            selectedPackets: null,
        }
    },
    computed: mapGetters({
        company: 'company',
        options: 'services',
        packets: 'packets',
        zones: 'zones',
    }),

    methods: {
        add() {
            this.$store
                .dispatch('companiesAddService', this.selectedService)
                .then(() => {
                    this.selectedService = null
                })
        },

        del(service) {
            this.$store.dispatch('companiesDelService', service)
        },

        modify(service) {
            this.$store.dispatch('companiesModService', service)
        },

        modifyPackets(service, selected) {
            this.$store.dispatch('companiesModifyPackets', {
                service_id: service.id,
                packets: selected,
            })
        },

        servicePackets(service) {
            return this.company.packets.filter(
                (x) => x.pivot.service_id == service.id
            )
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    label {{ $t('COMPANIES.ADD_SERVICE') }}
    .row.mb-4
        .col-24.col-sm.col-lg-12.col-xl-10
            acrm-multi-select.mb-3.mb-sm-0(
                :options="options"
                :multiple="false"
                track-by="id"
                option-label="translated"
                v-model="selectedService"
                :placeholder="$t('COMPANIES.ADD_ADDRESS_HINT')"
                )
        .col-24.col-sm-auto
            acrm-input-button(:disabled="selectedService == null" block icon="add" @click="add") {{ $t('BASE.ADD') }}

    acrm-tabs
        acrm-tab(:name="service.translated" v-for="(service, i) in company.services" :key="`${service.id}-${i}`" :service="service" dispatch="companiesDelService" :active="i===0" :tabKey="'service-' + i")
            acrm-heading(:level="4")
                span {{ $t('COMPANIES.SERVICE_SETTINGS')}}
            .row.mb-2
                .col.col-md-4
                    span {{ $t('COMPANIES.AS_CLIENT') }}
                .col-auto.col-md-20
                    acrm-input-switch(v-model="service.pivot.as_customer" @input="modify(service)")
            .row.mb-2
                .col.col-md-4
                    span {{ $t('COMPANIES.AS_PROVIDER') }}
                .col-auto.col-md-20
                    acrm-input-switch(v-model="service.pivot.as_provider" @input="modify(service)")
            .row.mb-2
                .col.col-md-4
                    span {{ $t('COMPANIES.PREPAID') }}
                .col-auto.col-md-20
                    acrm-input-switch(v-model="service.pivot.default_prepaid" @input="modify(service)")
            .row.mb-4
                .col-24.col-md-4
                    span {{ $t('COMPANIES.PACKETS') }}
                .col-24.col-md-12.mb-2
                    acrm-multi-select(
                        :options="packets"
                        :multiple="true"
                        track-by="id"
                        option-label="name"
                        :value="servicePackets(service)"
                        @input="modifyPackets(service, $event)"
                    )

            .row.mt-4
                .col-24 &nbsp;
            .row.mt-4
                .col-24 &nbsp;

            acrm-company-packet-prices(
                v-if="company"
                :service="service.id"
                :packets="company.packets"
            )

</template>
